import { useStudentData } from '@/hooks/useStudentData';
import { formatDate } from '@/lib/date';

const priorityMeta: Record<string, { label: string; icon: string; badge: string; border: string }> = {
  dusuk: { label: 'Düşük', icon: 'ri-information-line', badge: 'bg-secondary-100 text-secondary-700', border: 'border-secondary-100' },
  orta: { label: 'Orta', icon: 'ri-alert-line', badge: 'bg-amber-50 text-amber-600', border: 'border-amber-100' },
  yuksek: { label: 'Yüksek', icon: 'ri-error-warning-line', badge: 'bg-red-50 text-red-600', border: 'border-red-100' },
};

export default function StudentDuyurular() {
  const { group, announcements, loading, error, refetch } = useStudentData();

  if (loading) {
    return (
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-center py-20">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-200 border-t-primary-500" />
        <p className="mt-4 text-sm text-foreground-500">Duyurular yükleniyor...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mx-auto max-w-5xl py-10">
        <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-center">
          <i className="ri-error-warning-line text-2xl text-red-500" />
          <p className="mt-2 text-sm font-medium text-red-700">Duyurular yüklenirken bir hata oluştu.</p>
          <p className="mt-1 text-xs text-red-500">{error}</p>
          <button type="button" onClick={refetch} className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-primary-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-600 cursor-pointer">
            <i className="ri-refresh-line" /> Yeniden Dene
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">Duyurular</h1>
        <p className="mt-1 text-sm text-foreground-600">Öğretmeninizin duyurularını buradan takip edin.</p>
      </div>

      {!group ? (
        <div className="rounded-xl border border-background-200 bg-white p-10 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-100">
            <i className="ri-megaphone-line text-2xl text-foreground-400" />
          </div>
          <p className="text-sm font-semibold text-foreground-700">Henüz size atanmış bir grup bulunmuyor.</p>
          <p className="mt-1 text-xs text-foreground-500">Ders içerikleriniz tanımlandığında burada görünecek.</p>
        </div>
      ) : announcements.length === 0 ? (
        <div className="rounded-xl border border-background-200 bg-white p-10 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-100">
            <i className="ri-megaphone-line text-2xl text-foreground-400" />
          </div>
          <p className="text-sm font-semibold text-foreground-700">Henüz size ait bir duyuru bulunmuyor.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {announcements.map((a) => {
            const p = priorityMeta[a.priority] ?? priorityMeta.dusuk;
            return (
              <div key={a.id} className={`rounded-xl border bg-white p-5 ${p.border}`}>
                <div className="flex items-start gap-4">
                  <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${p.badge}`}>
                    <i className={`${p.icon} text-xl`} />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="mb-1 flex flex-wrap items-center gap-2">
                      <h3 className="font-semibold text-foreground-950 text-sm">{a.title}</h3>
                      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${p.badge}`}>
                        {p.label}
                      </span>
                      {!a.group_id && (
                        <span className="inline-flex items-center gap-1 rounded-full bg-background-100 px-2 py-0.5 text-[11px] font-semibold text-foreground-500">
                          <i className="ri-global-line" /> Tüm gruplar
                        </span>
                      )}
                    </div>
                    {a.message && (
                      <p className="text-sm text-foreground-600 whitespace-pre-wrap">{a.message}</p>
                    )}
                    <p className="mt-2 text-xs text-foreground-400">
                      {a.date ? formatDate(a.date) : '—'}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}